import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Input } from 'components/fields'
import {
  Anchor,
  Note,
  CenteredContent,
  CircleBadge,
  Title, InfoBubble
} from 'components/misc'
import { ElevatedButton } from 'components/layout'
import { form, modal } from 'helpers/decorators'
import Textarea from '../../../../components/fields/Textarea/Textarea'
import assessorApprovalValidation from '../../../../models/assessor/assessorApprovalValidation'
import MODALS from '../../../../constants/layout/modals'
import { InfoPersonalSummaryModal } from '../../../../components/modals'

@form({
  form: 'sendAssessorRequest',
  disableHook: true,
  validate: assessorApprovalValidation
})
@modal.trigger()
class AssessorApproval extends Component {
  static propTypes = {
    noAssessor: PropTypes.bool,
    loading: PropTypes.bool,
    onOpenAlreadyAssessed: PropTypes.func,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    reset: PropTypes.func,
    colorClass: PropTypes.string,
    isAssessorManagementEnabled: PropTypes.bool,
    isPersonalReflectionEnabled: PropTypes.bool,
    lastPersonalReflection: PropTypes.string,
    initialize: PropTypes.func,
    nestedModal: PropTypes.func
  }

  componentDidMount() {
    this.props.initialize({ personalReflection: this.props.lastPersonalReflection })
  }

  handleSubmit = fields =>
    this.props.onSubmit(fields, { resetForm: this.props.reset })

  handleOpenAlreadyAssessed = () => this.props.onOpenAlreadyAssessed()

  handleOpen = () => this.props.nestedModal(MODALS.INFO_PERSONAL_SUMMARY_MODAL)

  render() {
    const { loading, colorClass, noAssessor, handleSubmit, isAssessorManagementEnabled, isPersonalReflectionEnabled } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        {!noAssessor && (
          <div>
            <CenteredContent marginAuto>
              <CircleBadge colorClass={colorClass} large medal>
                <i className="ico ico--icon-victory" />
              </CircleBadge>
            </CenteredContent>
            <Title
              colorClass={colorClass}
              h2
              style={{ textAlign: 'center', paddingTop: '10px' }}
            >
              <FormattedMessage
                id="moduleTitle.congratulation"
                defaultMessage="Congratulation!"
              />
            </Title>
          </div>
        )}

        <Note margin="20px 0 30px">
          {noAssessor ? (
            <FormattedMessage
              id="label.this_activity_has_no_assessor"
              defaultMessage="This activity has no assessor. You must set assessors details before sending it for approval."
            />
          ) : (
            <FormattedMessage
              id="label.you_have_finished_now_send_to_approval"
              defaultMessage="You have finished. Now you can send to your Assessor to approval. If you want, you can add personal note also."
            />
          )}
        </Note>

        {!noAssessor && (
          <Input
            name="note"
            label="Note for assessor"
            intlKey="label.note_for_assessor"
            optional
          />
        )}

        {isPersonalReflectionEnabled && <Textarea name='personalReflection' maxLength={2000} label={<div className="row">
          <div className="col-xs-12">
            <div style={{ paddingRight: '45px' }}>
              <FormattedMessage
                id="label.activity_personal_reflection"
                defaultMessage='Your "personal reflection": Please share your thoughts and reflections on your Activity experience.'
              />
            </div>

            <div style={{ position: 'absolute', right: '23px', top: '0px' }}>
              <InfoBubble onClick={this.handleOpen} />
            </div>
          </div>
        </div>}
        />}

        {!noAssessor && (
          <ElevatedButton
            colorClass={colorClass}
            uppercase
            rounded
            submit
            padded
            fullWidth
            isLoading={loading}
            intlKey="button.send_for_approval"
          >
            Send for approval
          </ElevatedButton>
        )}

        <Anchor
          block
          center
          underline
          margin="15px 0 0"
          colorClass={colorClass}
        >
          {!isAssessorManagementEnabled && <a onClick={this.handleOpenAlreadyAssessed}>
            <FormattedMessage
              id="button.i_already_have_assessment"
              defaultMessage="I already have an assessment"
            />
          </a>}
        </Anchor>
        <InfoPersonalSummaryModal />
      </form>
    )
  }
}

export default AssessorApproval
